import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";

import Enroll from "../../services/enroll";
import StoreContext from "../../utils/Store/Context";

import { Container, Avatar, Grid, TextField, Button } from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import LockIcon from "@material-ui/icons/Lock";

import logo from "../../assets/images/FazendoMaisLogo.png";
import { Content, Logo, Title } from "./styles";
import { config } from "../../config";

const Login = () => {
    const [values, setValues] = useState({ email: "", password: "" });
    const [error, setError] = useState(null);
    const { setToken, setUser } = useContext(StoreContext);
    const history = useHistory();

    function onChange(event) {
        const { value, name } = event.target;
        setValues({ ...values, [name]: value });
    }

    async function onSubmit(event) {
        event.preventDefault();

        if (
            config.MODE === "test" &&
            values.email === config.WILDCARD_USER &&
            values.password === config.WILDCARD_PASS
        ) {
            setToken("*");
            setUser(config.WILDCARD_USER);
            return history.push("/");
        }

        if (
            config.MODE === "test" &&
            values.email === config.WILDCARD_USER_2 &&
            values.password === config.WILDCARD_PASS_2
        ) {
            setToken("**");
            setUser(config.WILDCARD_USER_2);
            return history.push("/");
        }

        const resp = await Enroll.login(values);
        if (resp) {
            setToken(resp.data.data.token);
            setUser(values.email);
            return history.push("/");
        }
        setError("Credenciais incorretas");
        setValues({ email: "", password: "" });
    }

    return (
        <Container component="main" maxWidth="sm">
            <Content>
                <Logo style={{ backgroundColor: "transparent" }}>
                    {/* <Avatar alt="logo" src={logo} /> */}
                    <img style={{ height: "10vh" }} alt="logo" src={logo} />
                </Logo>
                <Title>LOG IN</Title>
                <form onSubmit={onSubmit}>
                    <div>
                        <Grid container spacing={1} alignItems="flex-end">
                            <Grid item>
                                <AccountCircle style={{ color: "white" }} />
                            </Grid>
                            <Grid item>
                                <TextField
                                    label="Username"
                                    id="email"
                                    type="text"
                                    name="email"
                                    onChange={onChange}
                                    value={values.email}
                                />
                            </Grid>
                        </Grid>
                    </div>
                    <div>
                        <Grid container spacing={1} alignItems="flex-end">
                            <Grid item>
                                <LockIcon style={{ color: "white" }} />
                            </Grid>
                            <Grid item>
                                <TextField
                                    label="Password"
                                    id="password"
                                    type="password"
                                    name="password"
                                    onChange={onChange}
                                    value={values.password}
                                />
                            </Grid>
                        </Grid>
                    </div>
                    {error && <div className="user-login__error">{error}</div>}
                    <div className="content_button">
                        <Button className="button" type="submit" variant="contained" color="primary" disableElevation>
                            Login
                        </Button>
                    </div>
                </form>
            </Content>
        </Container>
    );
};

export default Login;
